export default __webpack_public_path__ + "static/media/in-active-category.33f670c6.svg";